import { schema } from 'normalizr'

// Types
import type { PaymentState } from 'types'

export type SavedPaymentMethod = {
  id: number
  variant: string
  card_number: string
  exp_month: string
  exp_year: string
  customer_name: string
  expired: boolean
}

export type AvailableCreditCardsData = {
  name: 'Credit Card'
  type: 'scheme'
  brands: Array<string>
  details: Array<{
    key: string
    type: string
    optional?: boolean
  }>
}

export type PayPalData = {
  name: 'PayPal'
  type: 'paypal'
  configuration: {
    intent: string
  }
}

export type PayState = {
  savedPaymentMethod: SavedPaymentMethod | undefined
  creditCards: AvailableCreditCardsData | undefined
  paypal: PayPalData | undefined
}

export type Payment = {
  amount: number // in cents
  id: number
  items: {
    headers: Array<string>
    items: Array<string>
  } | null
  completed_at: string
  external_id: string
  callback_url: string
  payment_formdata: Record<string, unknown>
}

export type ChangePaymentMethodOrder = {
  id: number
  state: PaymentState
  payment_url: string
}

export type ReceiptLink = {
  url: string
}

export const changePaymentMethodOrderSchema = new schema.Entity('changePaymentMethodOrders')
export const paymentSchema = new schema.Entity('payments')
export const paymentListSchema = [paymentSchema]
export const receiptLinkSchema = new schema.Entity('receiptLinks')
